
// tab 配置项
export const tabConfig = () => {
  return [
    {
      label: '车辆',
      name: 'detail',
      isShow: true,
      componentName: 'CarDetails',
    },
    {
      label: '证照',
      name: 'licence',
      isShow: true,
      componentName: 'LicenceDetails',
    },
    {
      label: '保险',
      name: 'policy',
      isShow: true,
      componentName: 'Policy',
    },
    {
      label: '事故',
      name: 'accident',
      isShow: true,
      componentName: 'CarAccidentList',
    },
    // 拆组件
    {
      label: '维保',
      name: 'maintenance',
      isShow: true,
      componentName: 'CarMaintenanceList',
    },
    {
      label: '违章',
      name: 'violation',
      isShow: true,
      componentName: 'CarViolation',
    },
    {
      label: '出入库记录',
      name: 'comeOutRecord',
      isShow: true,
      componentName: 'comeOutRecord',
    },
    {
      label: '个人订单',
      name: 'personRentOrder',
      isShow: true,
      componentName: 'personalOrder',
    },
    {
      label: '企业订单',
      name: 'enterpriseOrder',
      isShow: true,
      componentName: 'enterpriseChildOrder',
    },
  ]
}

// 跟进tab匹配对应详情组件
export const tabDetail = {
  comeOutRecord: 'outInDetails', // 出入库记录
  enterpriseChildOrder: 'personalOrderDetail', // 企业子订单
  personalOrder: 'personalOrderDetail', // 个人租赁订单详情
}
